export const tabs = [{ name: 'Company Info', code: 0 }, { name: 'Stores', code: 1 }];

export const BILL_ADDRESS_LIST = [
  { value: 1, label: 'Same as company address' },
  { value: 2, label: 'Use a separate billing address' },
];

export const getFirstRegion = (CountryRegionData, country) => {
  if (!country) {
    return [];
  }
  const contryInfo = CountryRegionData?.find((item) => item[1] === country) || {};
  return contryInfo[2]?.split('|').map((regionPair) => {
    const [regionName] = regionPair.split('~');
    return regionName;
  })[0];
};

export const BILL_EMAIL_LIST = [
  { value: 1, label: 'Same as account email' },
  { value: 2, label: 'Use a separate email' },
];
